import {IFreeToPlayService, IFreeToPlayShowOptions} from "./free-to-play.service.interface";
import {AnimatedIconBaseService, AnimatedIconObservableTarget} from "../pixi-app/animated-icon-base-service.service";

export class FreeToPlayService extends AnimatedIconBaseService implements IFreeToPlayService{
    loadFreeToPlayAnimation(options: AnimatedIconObservableTarget) {
        this.loadAnimatedIcon(options, "freeToPlayAnimatedIcon");
    }

    get iconIndex(): number {
        const abIndex = this.services.abTestingFeatureDataProvider.free2PlayIconNumber;
        return abIndex >= 1 && abIndex <= 2 ? abIndex : 2;
    }

    // this is a placeholder for further eligibility logic F2P has
    isPromotionEligible(): Promise<boolean> {
        return Promise.resolve(this.services.user.isAuthorized);
    }

    showPromotion(options: IFreeToPlayShowOptions): Promise<void> {
        return this.services.appLauncher.openBonusWheel({
            businessCorrelationID: this.services.tools.getGuid(),
            sequentialCorrelationID: 1,
            channel: options.channel,
            appSpecificParameters: options.appSpecificParameters
        });
    }
}